/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from "vue"
//import VueAnalytics from 'vue-analytics'
import Router from "vue-router"
import Meta from "vue-meta"

// Routes
import paths from "./paths"

function route(path, view, name, meta) {
    return {
        name: name || view,
        path,
        meta,
        component: resolve => import(`@/views/${view}.vue`).then(resolve)
    }
}

Vue.use(Router)

// Create a new router
const router = new Router({
    mode: "history",
    routes: paths
        .map(path => route(path.path, path.view, path.name, path.meta))
        .concat([{ path: "*", redirect: "/home" }]),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        if (to.hash) {
            return { selector: to.hash }
        }
        return { x: 0, y: 0 }
    }
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem("jwt") == null) {
            next({
                path: "/login",
                params: { nextUrl: to.fullPath }
            })
        } else {
            //let usuario = JSON.parse(localStorage.getItem("usuario") as string)
            next()
        }
    } else if (to.matched.some(record => record.meta.guest)) {
        next()
    }
    next()
})

Vue.use(Meta)

export default router
